"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteDirectionMutation = exports.useDirectionByIdQuery = exports.useGetDirectionsQuery = exports.useAddOrUpdateDirectionMutation = exports.DirectionApi = exports.prepareHeaders = void 0;
const react_1 = require("@reduxjs/toolkit/query/react");
const http_1 = require("../../http");
const storage_1 = require("../../storage");
const Utils_1 = require("../../Utils");
const prepareHeaders = (headers, { getState }) => {
    var _a, _b;
    const token = (_a = getState().user.token) !== null && _a !== void 0 ? _a : (_b = storage_1.AppStorage.getItem("user")) === null || _b === void 0 ? void 0 : _b.token;
    if (token) {
        headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
};
exports.prepareHeaders = prepareHeaders;
exports.DirectionApi = (0, react_1.createApi)({
    reducerPath: "directionApi",
    tagTypes: ["direction", "directionList", "directionById"],
    baseQuery: (0, react_1.fetchBaseQuery)({
        baseUrl: `${http_1.ApiBaseUrl}`,
        prepareHeaders: exports.prepareHeaders,
    }),
    endpoints: (builder) => ({
        addOrUpdateDirection: builder.mutation({
            invalidatesTags: ["direction", "directionList", "directionById"],
            query: ({ id, data }) => {
                if (id) {
                    return {
                        url: `directions/${id}/`,
                        method: "POST",
                        body: data,
                    };
                }
                return {
                    url: `directions/`,
                    method: "POST",
                    body: data,
                };
            },
        }),
        getDirections: builder.query({
            providesTags: ["directionList"],
            query: (query) => (0, Utils_1.QueryUrl)("directions", query),
        }),
        directionById: builder.query({
            query: (id) => `directions/${id}/`,
            providesTags: ["directionById"],
        }),
        deleteDirection: builder.mutation({
            query: (id) => ({
                url: `directions/${id}/`,
                method: "DELETE",
            }),
            invalidatesTags: ["direction", "directionList", "directionById"],
        }),
    }),
});
exports.useAddOrUpdateDirectionMutation = exports.DirectionApi.useAddOrUpdateDirectionMutation, exports.useGetDirectionsQuery = exports.DirectionApi.useGetDirectionsQuery, exports.useDirectionByIdQuery = exports.DirectionApi.useDirectionByIdQuery, exports.useDeleteDirectionMutation = exports.DirectionApi.useDeleteDirectionMutation;
